import * as actionTypes from './actionTypes';

export const toggleSideDrawer = () => {
  return {
    type: actionTypes.TOGGLE_SIDE_DRAWER,
  };
};

export const getAvailableServersStart = () => {
  return {
    type: actionTypes.GET_AVAILABLE_SERVERS_START,
  };
};

export const getAvailableServersSuccess = (servers) => {
  return {
    type: actionTypes.GET_AVAILABLE_SERVERS_SUCCESS,
    servers,
  };
};

export const getAvailableServersFailed = (error) => {
  return {
    type: actionTypes.GET_AVAILABLE_SERVERS_FAILED,
    error,
  };
};

export const setSelectedServerStart = () => {
  return {
    type: actionTypes.SET_SELECTED_SERVER_START,
  };
};

export const setSelectedServerSuccess = (server) => {
  return {
    type: actionTypes.SET_SELECTED_SERVER_SUCCESS,
    server,
  };
};

export const updateScrollToTopOfChild = (scrollToTop) => {
  return {
    type: actionTypes.UPDATE_SCROLL_TO_TOP_OF_CHILD,
    scrollToTop,
  };
};

export const logAppError = (errorTitle, errorMessage) => {
  return {
    type: actionTypes.LOG_APP_ERROR,
    errorTitle,
    errorMessage,
  };
};

export const clearAppError = () => {
  return {
    type: actionTypes.CLEAR_APP_ERROR,
  };
};
